import type { StoreOperatingHourEntry } from '~/services/api/generated'
import type { TranslateFn } from './TranslateFn'
import { closesNextDay } from '~/utils/closesNextDay'
import { formatStoreTime } from '~/utils/formatStoreTime'
import { isOpenAllDay } from '~/utils/isOpenAllDay'
import { normalizeStoreTimeForInput } from '~/utils/normalizeStoreTimeForInput'
import type { TodayServiceHours } from './TodayServiceHours'

/** Reads the store's single service-hours schedule for one day of the week (lowercase key). */
export const describeTodayServiceHours = (
  hours: readonly StoreOperatingHourEntry[],
  dayKey: string,
  t: TranslateFn
): TodayServiceHours => {
  const todayHour = hours.find((hour) => hour.day_of_week.toLowerCase() === dayKey)
  if (todayHour === undefined)
    return { closesNextDay: false, value: t('dashboard.labels.serviceHoursNotConfigured') }
  if (!todayHour.is_open)
    return { closesNextDay: false, value: t('dashboard.labels.serviceHoursClosedToday') }

  const openTime = normalizeStoreTimeForInput(todayHour.open_time)
  const closeTime = normalizeStoreTimeForInput(todayHour.close_time)
  if (isOpenAllDay(openTime, closeTime)) {
    return { closesNextDay: false, value: t('dashboard.labels.serviceHoursOpenAllDay') }
  }

  return {
    closesNextDay: closesNextDay(openTime, closeTime),
    value: `${formatStoreTime(todayHour.open_time)} – ${formatStoreTime(todayHour.close_time)}`
  }
}
